import { useContext } from 'react';

import { PromptContext } from '../model';

export function usePrompt() {
  return useContext(PromptContext);
}
